export class ApiError<T> extends Error {
    code: T

    constructor(code: T, message?: string) {
        super(message)
        this.code = code
    }

    get name(): string {
        return this.constructor.name
    }
}
